export default {
  form: document.querySelector('.feedback-form'),
  btn: document.querySelector('.feedback-form button'),
};
